"use client";
import { cva as e } from "class-variance-authority";
const o = e("", {
  variants: {
    section: {
      wrapper: "w-full flex flex-col grow-[5] overflow-hidden justify-between max-h-full",
      header: "relative max-h-full",
      content: "w-full flex flex-col overflow-hidden p-0 grow-[2]",
      footer: "justify-self-end flex-shrink-0"
    }
  }
});
export {
  o as scrollable
};
